import React, {Component} from 'react';
import {connect} from 'react-redux';
import {
    Button,
    Grid,
    Paper,
    Tooltip,
    IconButton,
    withStyles,
} from 'material-ui';
import {Input, Typography, Divider} from 'material-ui';
import Dialog from 'material-ui/Dialog';
import {DialogActions, DialogContent, DialogTitle} from 'material-ui/Dialog';
import AddIcon from 'material-ui-icons/NoteAdd';
import {BackDropCMS} from '../../components/backdrop/backdrop_cms';
import pagePickerStyles from './style';
import {fetchedPages, searchByTitle} from './actions';

class PagePicker extends Component {
    componentWillUnmount() {
        this.props.searchByTitle('');
        this.props.fetchedPages([]);
    }

    render() {
        const {
            handleClose,
            onPick,
            open,
            classes,
            searchString,
            onSearchPages,
            allPagesBySearchCriteria,
        } = this.props;

        return (
            <Dialog
                open={open}
                onClose={handleClose}
                fullWidth
                maxWidth={false}
                classes={{
                    paper: classes.paperDialog,
                    fullWidth: classes.fullWidth,
                }}
                BackdropComponent={BackDropCMS}
            >
                <DialogTitle>{'Select a Page'}</DialogTitle>
                <DialogContent className={classes.pagePickerDialogContent}>
                    <Grid container>
                        <Input
                            name="pages"
                            placeholder="Please type page name here"
                            fullWidth={true}
                            value={searchString}
                            onChange={onSearchPages}
                            autoFocus={true}
                            className={classes.inputSearchPage}
                            autoComplete="off"
                        />
                        <Paper className={classes.pagesSearchResults}>
                            <Grid item xs={12}>
                                {allPagesBySearchCriteria.length === 0 &&
                                searchString !== '' ? (
                                    <Grid
                                        container
                                        justify="center"
                                        className={classes.loadingText}
                                    >
                                        Loading...
                                    </Grid>
                                ) : (
                                    ''
                                )}
                                {allPagesBySearchCriteria.length !== 0 &&
                                searchString !== '' ? (
                                    <span>
                                        <Grid
                                            container
                                            className={
                                                classes.pagesSearchResultsItems
                                            }
                                        >
                                            <Grid item md={6}>
                                                <Typography
                                                    className={
                                                        classes.headingPageSearch
                                                    }
                                                >
                                                    <strong>Page Title</strong>
                                                </Typography>
                                            </Grid>
                                            <Grid item md={5}>
                                                <Typography
                                                    className={
                                                        classes.headingPageSearch
                                                    }
                                                >
                                                    <strong>Page Type</strong>
                                                </Typography>
                                            </Grid>
                                            <Grid item md={1}>
                                                <Typography
                                                    className={
                                                        classes.headingPageSearch
                                                    }
                                                >
                                                    <strong>Action</strong>
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                        <Divider />
                                    </span>
                                ) : (
                                    ''
                                )}
                                {allPagesBySearchCriteria.map((page) => (
                                    <Grid item key={page.id}>
                                        <Grid
                                            container
                                            className={
                                                classes.pagesSearchResultsItems
                                            }
                                        >
                                            <Grid item md={6}>
                                                <Typography
                                                    className={
                                                        classes.headingPageSearch
                                                    }
                                                >
                                                    {page.title}
                                                </Typography>
                                            </Grid>
                                            <Grid item md={5}>
                                                <Typography
                                                    className={
                                                        classes.headingPageSearch
                                                    }
                                                >
                                                    {page.type}
                                                </Typography>
                                            </Grid>
                                            <Grid item md={1}>
                                                <Tooltip title="Add Page">
                                                    <IconButton
                                                        className="smallIconButton editColor"
                                                        onClick={(e) =>
                                                            onPick(
                                                                page.id,
                                                                page.title
                                                            )
                                                        }
                                                    >
                                                        <AddIcon />
                                                    </IconButton>
                                                </Tooltip>
                                            </Grid>
                                        </Grid>
                                        <Divider />
                                    </Grid>
                                ))}
                            </Grid>
                        </Paper>
                    </Grid>
                </DialogContent>
                <DialogActions className={classes.dialogActionsButtons}>
                    <Button
                        onClick={handleClose}
                        variant="raised"
                        className={classes.buttons}
                    >
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

export default connect(null, {searchByTitle, fetchedPages})(
    withStyles(pagePickerStyles)(PagePicker)
);



// WEBPACK FOOTER //
// ./src/containers/page-picker/page_picker.js